/* SylkenShop theme JS — sin dependencias */
(function () {
  'use strict';
  var S = window.Sylken || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || S.moneyFormat || '€{{amount_with_comma_separator}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, prec, th, dec) {
      th = th || ','; dec = dec || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(prec);
      var p = n.split('.');
      var d = p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (p[1] ? dec + p[1] : '');
    }
    var m = format.match(re), v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2, '.', ',');
    }
    return format.replace(re, v);
  }
  S.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }
  S.toast = toast;

  /* ---------- Drawers & modals ---------- */
  function openEl(el) { if (!el) return; el.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; var f = el.querySelector('input:not([type=hidden]),button,a'); if (f) setTimeout(function(){ f.focus({preventScroll:true}); }, 50); }
  function closeEl(el) { if (!el) return; el.classList.remove('is-open'); if (!$('.drawer.is-open, .modal.is-open, .search-overlay.is-open')) document.documentElement.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); var t = document.getElementById(o.getAttribute('data-open')); if (t && t.id === 'CartDrawer') { refreshCartDrawer().then(function(){ openEl(t); }); } else openEl(t); return; }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closeEl(c.closest('.drawer, .modal, .search-overlay')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open, .modal.is-open, .search-overlay.is-open').forEach(closeEl);
  });

  /* ---------- Cart API ---------- */
  function cartGet() { return fetch(S.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }

  function lineHTML(item, i) {
    var img = item.image ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" width="200" height="200">' : '';
    var opts = (item.options_with_values || []).filter(function (o) { return o.name !== 'Title'; }).map(function (o) { return o.name + ': ' + o.value; }).join(' · ');
    var cmp = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
    return '<div class="line" data-line="' + (i + 1) + '">' +
      '<a class="line__img" href="' + item.url + '">' + img + '</a>' +
      '<div><div class="line__top"><div><p class="line__title"><a href="' + item.url + '">' + item.product_title + '</a></p>' +
      (opts ? '<p class="line__opts">' + opts + '</p>' : '') + '</div>' +
      '<div class="line__price">' + cmp + formatMoney(item.final_line_price) + '</div></div>' +
      '<div class="line__bottom"><div class="qty"><button type="button" data-qty-change="' + (i + 1) + '" data-delta="-1" aria-label="Quitar uno">−</button>' +
      '<input type="number" value="' + item.quantity + '" min="0" aria-label="Cantidad" data-qty-input="' + (i + 1) + '"><button type="button" data-qty-change="' + (i + 1) + '" data-delta="1" aria-label="Añadir uno">+</button></div>' +
      '<button type="button" class="line__remove" data-remove="' + (i + 1) + '">Eliminar</button></div></div></div>';
  }

  function refreshCartDrawer() {
    var d = $('#CartDrawer');
    return cartGet().then(function (cart) {
      setCount(cart.item_count);
      if (!d) return cart;
      var body = $('[data-cart-body]', d), foot = $('[data-cart-foot]', d);
      if (!cart.item_count) {
        body.innerHTML = $('[data-cart-empty-tpl]', d).innerHTML;
        foot.hidden = true;
      } else {
        body.innerHTML = cart.items.map(lineHTML).join('');
        foot.hidden = false;
        $$('[data-cart-total]', d).forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
        var disc = cart.original_total_price - cart.total_price;
        var dr = $('[data-cart-discount-row]', d);
        if (dr) { dr.hidden = disc <= 0; $('[data-cart-discount]', d).textContent = '−' + formatMoney(disc); }
      }
      return cart;
    });
  }
  S.refreshCartDrawer = refreshCartDrawer;

  function changeLine(line, qty) {
    return fetch(S.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status && cart.description) toast(cart.description);
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        refreshCartDrawer();
      });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty-change]');
    if (q) {
      var line = +q.getAttribute('data-qty-change'); var input = $('[data-qty-input="' + line + '"]', q.closest('.line'));
      var v = Math.max(0, (+input.value || 0) + (+q.getAttribute('data-delta')));
      input.value = v; changeLine(line, v); return;
    }
    var r = e.target.closest('[data-remove]');
    if (r) { e.preventDefault(); changeLine(+r.getAttribute('data-remove'), 0); }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-qty-input]');
    if (i) changeLine(+i.getAttribute('data-qty-input'), Math.max(0, +i.value || 0));
  });

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-atc-form]');
    if (!form) return;
    var buyNow = e.submitter && e.submitter.hasAttribute('data-buy-now');
    e.preventDefault();
    var btns = $$('button[type=submit]', form); btns.forEach(function (b) { b.classList.add('is-loading'); });
    fetch(S.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || 'No se pudo añadir'); return; }
        if (buyNow || form.hasAttribute('data-go-cart')) { window.location.href = S.routes.cart; return; }
        if (S.openCartOnAdd) refreshCartDrawer().then(function () { openEl($('#CartDrawer')); });
        else { refreshCartDrawer(); toast('Añadido a tu carrito ✓'); }
      })
      .catch(function () { form.submit(); })
      .finally(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); }); });
  });

  /* ---------- Cart page: required phones ---------- */
  var cartForm = $('form[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('submit', function (e) {
      if (!(e.submitter && e.submitter.name === 'checkout')) return;
      var ok = true, first;
      $$('[data-required-phone]', cartForm).forEach(function (inp) {
        var f = inp.closest('.field'); var digits = (inp.value || '').replace(/\D/g, '');
        var bad = digits.length < 9;
        if (!bad && inp.hasAttribute('data-must-differ')) {
          var other = $('#' + inp.getAttribute('data-must-differ'));
          if (other && other.value.replace(/\D/g, '') === digits) bad = true;
        }
        f.classList.toggle('has-error', bad);
        if (bad) { ok = false; first = first || inp; }
      });
      if (!ok) { e.preventDefault(); first.focus(); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); toast('Revisa los teléfonos de contacto'); }
    });
    $$('[data-required-phone]', cartForm).forEach(function (inp) {
      inp.addEventListener('input', function () { inp.closest('.field').classList.remove('has-error'); });
    });
  }

  /* ---------- Hero slideshow ---------- */
  $$('[data-slideshow]').forEach(function (root) {
    var track = $('.hero__slides', root), slides = $$('.hero__slide', root), dots = $$('.hero__dot', root);
    if (slides.length < 2) return;
    var i = 0, timer, speed = (+root.getAttribute('data-speed') || 5) * 1000;
    function go(n) { i = (n + slides.length) % slides.length; track.style.transform = 'translateX(' + (-i * 100) + '%)'; dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); }
    function play() { if (root.hasAttribute('data-autoplay')) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed); } }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); } x0 = null; });
    play();
  });

  /* ---------- Carousel arrows ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-scroll]');
    if (!b) return;
    var t = document.getElementById(b.getAttribute('data-target'));
    if (t) t.scrollBy({ left: (b.getAttribute('data-scroll') === 'next' ? 1 : -1) * t.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- Video cards ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vid-play]');
    if (!b) return;
    var card = b.closest('[data-vid]'), v = card && $('video', card);
    if (!v) return;
    $$('[data-vid] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-vid]').classList.remove('is-playing'); } });
    if (v.paused) { v.muted = false; v.play(); card.classList.add('is-playing'); } else { v.pause(); card.classList.remove('is-playing'); }
  });
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-vid].is-playing video');
    if (v) { v.pause(); v.closest('[data-vid]').classList.remove('is-playing'); }
  });

  /* ---------- Delivery estimate ---------- */
  var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function addBusinessDays(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; } return r; }
  function fmtDay(d) { return DAYS[d.getDay()] + ', ' + d.getDate() + ' de ' + MONTHS[d.getMonth()]; }
  function deliveryInfo() {
    var now = new Date(), cut = S.cutoffHour || 17, ship = new Date(now);
    var weekend = now.getDay() === 0 || now.getDay() === 6;
    if (weekend || now.getHours() >= cut) { ship = addBusinessDays(now, 1); }
    var min = addBusinessDays(ship, S.deliveryDaysMin || 1), max = addBusinessDays(ship, S.deliveryDays || 2);
    var left = null;
    if (!weekend && now.getHours() < cut) { var c = new Date(now); c.setHours(cut, 0, 0, 0); var ms = c - now; left = Math.floor(ms / 3600000) + ' h ' + Math.floor((ms % 3600000) / 60000) + ' min'; }
    return { min: min, max: max, left: left };
  }
  function renderDelivery() {
    $$('[data-delivery]').forEach(function (el) {
      var info = deliveryInfo();
      var d = $('[data-delivery-date]', el);
      if (d) d.textContent = info.min.toDateString() === info.max.toDateString() ? fmtDay(info.min) : fmtDay(info.min) + ' – ' + fmtDay(info.max);
    });
    $$('[data-delivery-left]').forEach(function (l) {
      var info = deliveryInfo();
      if (info.left) { l.hidden = false; $('span', l).textContent = info.left; } else l.hidden = true;
    });
  }
  renderDelivery(); setInterval(renderDelivery, 60000);

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('[data-product-json]', root); if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('form[data-atc-form]', root), idInput = $('input[name=id]', form);
    var priceEl = $('[data-price]', root), cmpEl = $('[data-compare]', root), badgeEl = $('[data-badge]', root);
    var btns = $$('[data-atc-btn]', root), btnPrice = $$('[data-btn-price]', root);
    var sticky = $('[data-sticky-atc]');

    function selected() { return $$('[data-option-index]', root).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
    function findVariant(opts) { return product.variants.find(function (v) { return v.options.every(function (o, k) { return o === opts[k]; }); }); }
    function markAvailability() {
      var opts = selected();
      $$('[data-option-index]', root).forEach(function (g) {
        var idx = +g.getAttribute('data-option-index');
        $$('input', g).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var v = findVariant(test); var lab = inp.nextElementSibling;
          if (lab) lab.classList.toggle('is-out', !v || !v.available);
        });
      });
    }
    function update() {
      var v = findVariant(selected());
      markAvailability();
      $$('[data-selected-value]', root).forEach(function (el) { var g = el.closest('[data-option-index]'); var c = g && $('input:checked', g); if (c) el.textContent = c.value; });
      if (!v) { btns.forEach(function (b) { b.disabled = true; }); $$('[data-btn-label]', root).forEach(function (l) { l.textContent = 'No disponible'; }); var ae = $('[data-availability]', root); if (ae) { ae.textContent = 'No disponible'; ae.classList.add('instock--out'); } return; }
      idInput.value = v.id;
      if (priceEl) { priceEl.textContent = formatMoney(v.price); }
      if (cmpEl) { cmpEl.hidden = !(v.compare_at_price > v.price); cmpEl.textContent = formatMoney(v.compare_at_price || 0); }
      if (badgeEl) { var pct = v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0; badgeEl.hidden = !pct; badgeEl.textContent = '−' + pct + ' %'; }
      var saveEl = $('[data-save]', root);
      if (saveEl) { var sv = v.compare_at_price > v.price ? v.compare_at_price - v.price : 0; saveEl.hidden = !sv; var sa = $('[data-save-amount]', saveEl); if (sa) sa.textContent = formatMoney(sv); }
      var avEl = $('[data-availability]', root);
      if (avEl) { avEl.textContent = v.available ? '✓ ' + avEl.getAttribute('data-in') : avEl.getAttribute('data-out'); avEl.classList.toggle('instock--out', !v.available); }
      btnPrice.forEach(function (el) { el.textContent = formatMoney(v.price); });
      btns.forEach(function (b) { b.disabled = !v.available; });
      $$('[data-btn-label]', root).forEach(function (l) { l.textContent = v.available ? l.getAttribute('data-label') : 'Agotado'; });
      if (sticky) { var sp = $('[data-sticky-price]', sticky); if (sp) sp.textContent = formatMoney(v.price); var sb = $('button', sticky); if (sb) sb.disabled = !v.available; }
      if (v.featured_media) {
        var slide = $('[data-media-id="' + v.featured_media.id + '"]', root);
        if (slide) slide.parentNode.scrollTo({ left: slide.offsetLeft - slide.parentNode.offsetLeft, behavior: 'smooth' });
      }
      if (history.replaceState && root.hasAttribute('data-update-url')) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    }
    root.addEventListener('change', function (e) { if (e.target.closest('[data-option-index]')) update(); });
    markAvailability();

    // qty
    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { var i = $('input[name=quantity]', form); i.value = Math.max(1, (+i.value || 1) + (+b.getAttribute('data-qty-step'))); });
    });

    // gallery
    var main = $('.gallery__main', root), thumbs = $$('.gallery__thumbs button', root), counter = $('[data-gallery-count]', root);
    if (main) {
      var slidesG = $$('.gallery__slide', main);
      main.addEventListener('scroll', function () {
        var k = Math.round(main.scrollLeft / main.clientWidth);
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === k); });
        if (counter) counter.textContent = (k + 1) + ' / ' + slidesG.length;
      }, { passive: true });
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { main.scrollTo({ left: j * main.clientWidth, behavior: 'smooth' }); }); });
    }

    // sticky add to cart
    if (sticky && form) {
      var io = new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); });
      io.observe(form);
      $('button', sticky).addEventListener('click', function () {
        var main = $('[data-atc-btn]', form); if (main) main.click();
      });
    }
  });

  /* ---------- Facets: auto-submit sort ---------- */
  $$('[data-autosubmit]').forEach(function (el) { el.addEventListener('change', function () { el.form.submit(); }); });
  // close facet dropdowns when clicking outside
  document.addEventListener('click', function (e) { $$('details.facet[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); }); });

  /* ---------- Tracking page ---------- */
  $$('[data-track-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = $('input', form), code = (input.value || '').trim().replace(/\s+/g, '').toUpperCase();
      var out = $('[data-track-result]', form.parentNode);
      if (code.length < 4) { out.innerHTML = '<p class="form-msg form-msg--err">Introduce el número de seguimiento que te llegó por SMS.</p>'; input.focus(); return; }
      var tpl = form.getAttribute('data-url') || '', base = form.getAttribute('data-base') || '';
      var url = tpl.indexOf('{code}') > -1 ? tpl.replace('{code}', encodeURIComponent(code)) : base;
      var copied = false;
      var done = function () {
        if (url) {
          out.innerHTML = '<p class="form-msg form-msg--ok">' + (tpl.indexOf('{code}') > -1 ? 'Abriendo el seguimiento de tu paquete…' : (copied ? 'Código copiado. Pégalo en la web del transportista que se ha abierto.' : 'Copia tu código y pégalo en la web del transportista.')) + '</p><p><a class="btn btn--outline" href="' + url + '" target="_blank" rel="noopener">Abrir seguimiento</a></p>';
          window.open(url, '_blank', 'noopener');
        } else {
          out.innerHTML = '<p class="form-msg">Escríbenos con tu número de seguimiento y te decimos dónde está tu paquete.</p>';
        }
      };
      if (navigator.clipboard && tpl.indexOf('{code}') === -1) navigator.clipboard.writeText(code).then(function () { copied = true; done(); }, done); else done();
    });
  });

  /* ---------- Search overlay (predictive) ---------- */
  var so = $('#SearchOverlay');
  if (so) {
    var inp = $('input[name=q]', so), res = $('[data-predictive]', so), t;
    inp.addEventListener('input', function () {
      clearTimeout(t); var q = inp.value.trim();
      if (q.length < 2) { res.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch(S.routes.root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var ps = (j.resources && j.resources.results.products) || [];
            res.innerHTML = ps.length ? ps.map(function (p) {
              var im = (p.featured_image && p.featured_image.url) || p.image || ''; if (im) im += (im.indexOf('?') > -1 ? '&' : '?') + 'width=120';
              return '<a class="pred-item" href="' + p.url + '"><span class="pred-thumb">' + (im ? '<img src="' + im + '" alt="">' : '') + '</span>' + '<div><strong style="text-transform:uppercase;font-size:14px">' + p.title + '</strong><div class="muted" style="font-size:13px">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</div></div></a>';
            }).join('') + '<p style="margin-top:16px"><a class="btn btn--outline" href="' + S.routes.root + 'search?q=' + encodeURIComponent(q) + '&type=product">Ver todos los resultados</a></p>' : '<p class="muted">Sin resultados para “' + q.replace(/</g, '&lt;') + '”.</p>';
          });
      }, 250);
    });
  }

  /* ---------- Help chat ---------- */
  var chat = $('[data-chat]');
  if (chat) {
    var panel = $('.chat__panel', chat), log = $('.chat__log', chat);
    $('.chat__toggle', chat).addEventListener('click', function () { panel.classList.toggle('is-open'); });
    $('[data-chat-close]', chat).addEventListener('click', function () { panel.classList.remove('is-open'); });
    $$('.chat__chips button', chat).forEach(function (b) {
      b.addEventListener('click', function () {
        var me = document.createElement('div'); me.className = 'chat__msg chat__msg--me'; me.textContent = b.textContent; log.appendChild(me);
        var bot = document.createElement('div'); bot.className = 'chat__msg'; bot.innerHTML = $('template[data-answer="' + b.getAttribute('data-q') + '"]', chat).innerHTML;
        setTimeout(function () { log.appendChild(bot); log.scrollTop = log.scrollHeight; }, 350);
        log.scrollTop = log.scrollHeight;
      });
    });
  }

  /* ---------- Newsletter popup ---------- */
  var pop = $('#NewsletterPopup');
  if (pop && !/customer_posted=true/.test(location.search)) {
    var seen = false; try { seen = localStorage.getItem('sylken_popup') === '1'; } catch (e) {}
    if (!seen) setTimeout(function () { openEl(pop); try { localStorage.setItem('sylken_popup', '1'); } catch (e) {} }, (+pop.getAttribute('data-delay') || 8) * 1000);
  }

  /* init cart count */
  document.addEventListener('DOMContentLoaded', function () {});
})();
